import React from 'react';
import { Handle, Position } from '@xyflow/react';
import { getStepIconConfig } from '../../utils/workflowNodeTypes';
import './workflowStepNode.css';

export default function WorkflowStepNode({ data, selected }) {
  const nodeKind = data?.nodeKind || 'html';
  const iconConfig = getStepIconConfig(data?.stepType);
  const title = data?.label || 'Step';
  const showDetailedContent = Boolean(data?.showDetailedContent);
  const previewText = data?.previewText || '';
  const hasValidationError = Boolean(data?.hasValidationError);
  const hasValidationWarning = Boolean(data?.hasValidationWarning);
  const validationErrorCount = data?.validationErrorCount || 0;
  const validationMessages = data?.validationMessages || [];

  return (
    <div
      className={`workflow-step-node workflow-step-node--${nodeKind} ${
        selected ? 'workflow-step-node--selected' : ''
      } ${hasValidationError ? 'workflow-step-node--error' : ''} ${
        !hasValidationError && hasValidationWarning ? 'workflow-step-node--warning' : ''
      }`}
      title={validationMessages.length > 0 ? validationMessages.join('\n') : undefined}
    >
      <Handle type="target" position={Position.Left} />
      {validationErrorCount > 0 && (
        <span
          className={`workflow-step-node__validation-badge ${
            hasValidationError
              ? 'workflow-step-node__validation-badge--error'
              : 'workflow-step-node__validation-badge--warning'
          }`}
          aria-label={`${validationErrorCount} validation issue(s)`}
        >
          {validationErrorCount > 9 ? '9+' : validationErrorCount}
        </span>
      )}
      <div className="workflow-step-node__header">
        <span
          className="workflow-step-node__icon"
          style={{
            color: iconConfig.color,
            backgroundColor: `${iconConfig.color}1a`,
          }}
          aria-hidden="true"
        >
          <i className={`bi ${iconConfig.icon}`} />
        </span>
        <span className="workflow-step-node__title">{title}</span>
      </div>
      {showDetailedContent && nodeKind !== 'start' && previewText && (
        <div className="workflow-step-node__preview">{previewText}</div>
      )}
      <Handle type="source" position={Position.Right} />
    </div>
  );
}
